import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import styled from '@emotion/native';
import { Swiper, SwiperSlide } from 'swiper/swiper-react';
import 'swiper/swiper.css';
import { Autoplay } from 'swiper/modules';

interface Props {
  children: React.ReactNode;
  maxWidth: number;
  containerStyle?: StyleProp<ViewStyle>;
  loop?: boolean;
  centeredSlides?: boolean;
  autoplay?: boolean;
}

const HorizontalCarousel = ({
  maxWidth,
  children,
  containerStyle,
  loop = false,
  centeredSlides = true,
  autoplay = false,
}: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const swiperRef = React.useRef<any>(null);

  // Force autoplay to start after mount
  React.useEffect(() => {
    if (autoplay && swiperRef.current?.swiper) {
      const timer = setTimeout(() => {
        swiperRef.current.swiper.autoplay.start();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [autoplay, children]);

  return (
    <SwiperContainer maxWidth={maxWidth} style={containerStyle}>
      <Swiper
        ref={swiperRef}
        slidesPerView="auto"
        direction="horizontal"
        centerInsufficientSlides
        style={swiperStyle}
        loop={loop}
        centeredSlides={centeredSlides}
        autoplay={
          autoplay
            ? {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
                waitForTransition: true,
              }
            : false
        }
        modules={[Autoplay]}
      >
        {React.Children.map(children, (child) => (
          <SwiperSlide style={swiperSlideStyle}>{child}</SwiperSlide>
        ))}
      </Swiper>
    </SwiperContainer>
  );
};

export default HorizontalCarousel;

const SwiperContainer = styled.View(({ maxWidth }: { maxWidth: number }) => ({
  flex: 1,
  maxWidth,
  justifyContent: 'center',
  alignItems: 'center',
  marginHorizontal: 'auto',
  overflow: 'hidden',
  userSelect: 'none',
}));

const swiperStyle: React.CSSProperties = {
  width: '100%',
};

const swiperSlideStyle: React.CSSProperties = {
  width: 'auto',
};
